import { JaneGoldIcon, Tag } from '@iheartjane/reefer';
import type { MarginProperties } from '@iheartjane/reefer';

export interface JaneGoldTagProps extends MarginProperties {
  label: string;
}
export const JaneGoldTag = ({ label, ...marginProps }: JaneGoldTagProps) => {
  return (
    <Tag
      label={label}
      color="grays-black"
      background="gold"
      icon={<JaneGoldIcon data-testid="jane-gold-icon" size="sm" />}
      {...marginProps}
    />
  );
};
